"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    require("../lji").default.name,
    require("superdesk-analytics").default.name
];



//////////////////
// WEBPACK FOOTER
// ./dist/app-importer.generated.js
// module id = 2488
// module chunks = 0